module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.loading) ? _h('div', ["Loading... "]) : _vm._e(), " ", (!_vm.result) ? _h('div', [_vm._s(_vm.result_msg)]) : _vm._e(), " ", (_vm.loadError) ? _h('div', ["数据加载失败, 请稍候再试"]) : _vm._e(), " ", (_vm.result) ? _h('div', {
    attrs: {
      "id": "home"
    }
  }, [_h('hello', {
    attrs: {
      "heads": _vm.heads
    }
  }), " ", _vm._l((_vm.calcs), function(calc) {
    return _h('calc', {
      attrs: {
        "name": calc.name,
        "value": calc.value,
        "minus": calc.minus,
        "unit": calc.unit
      }
    })
  }), " ", _vm._l((_vm.standards), function(standard) {
    return _h('standard', {
      attrs: {
        "name": standard.name,
        "value": standard.value,
        "minus": standard.minus,
        "unit": standard.unit
      }
    })
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d4faccb4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/versus.vue
// module id = 29
// module chunks = 1